import { IIdentifiable, isIdentifiable } from "@/loader";

export interface IDeletable extends IIdentifiable {
	delete?: boolean;
}

export function isDeletable(object: any): object is IDeletable {
	return isIdentifiable(object) && "delete" in object;
}
